import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        titleObj:'',
        imgupdate:'',
        user: {},
        token: null,
        title: '',
        reset:false,
        construction:'',
        selected:'',
    },
    mutations: {
        increment1 (state) {
            window.localStorage.setItem('token','token')
        },
        increment0 (state) {
            window.localStorage.removeItem("token");
        },
        [types.LOGIN]: (state, data) => {
            localStorage.token = data;
            state.token = data;
        },
        [types.LOGOUT]: (state) => {
            localStorage.removeItem('token');
            state.token = null
        },
        [types.TITLE]: (state, data) => {
            state.title = data;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js